import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-slate-900 selection:bg-teal-100 selection:text-teal-900" data-id="element-196">
      <Hero data-id="element-197" />
      <ProblemSection data-id="element-198" />
      <SolutionSection data-id="element-199" />
      <BonusSection data-id="element-200" />
      <PricingSection data-id="element-201" />
      <TestimonialSection data-id="element-202" />

      {/* Footer simple */}
      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-203">
        <div className="container mx-auto px-4" data-id="element-204">
          <p data-id="element-205">
            © {new Date().getFullYear()} Sistema Profesional de Intervención en
            Dislexia.
          </p>
          <p className="mt-2" data-id="element-206">Todos los derechos reservados.</p>
        </div>
      </footer>

      <PurchasePopup data-id="element-207" />
    </main>;
}